import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { toast } from 'react-hot-toast'

import msalInstance from 'config/msalConfig'
import { localStorageFields } from 'utils/constants/ui'

export const apiUrl = process.env.REACT_APP_API_URL

const axiosInstance: AxiosInstance = axios.create({
  baseURL: apiUrl,
  timeout: 30000, // Set the request timeout (in milliseconds)
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const configDetails = config
    const token = localStorage.getItem(localStorageFields.jwtToken)
    if (!configDetails?.headers?.Authorization) {
      if (token) configDetails.headers.Authorization = token
    }
    return configDetails
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    toast.error(
      error?.response?.data?.message || error.message || 'Something went wrong!'
    )
    if (error?.response?.status === 401) {
      const logout = async () => {
        msalInstance.logoutRedirect()
      }
      logout()
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
